import { getLanguage, Language } from '@/shared/lib/i18n';
import { workdayOptions } from '../../DialogContext/modals/EnrichVacancyModal/utils/EnrichVacancyModal.constants';

export const extractAvailableDays = (availableDays: string | undefined): string | undefined => {
  if (!availableDays) return undefined;

  const language = getLanguage();

  return availableDays
    .split(',')
    .map((day) => replaceOrKeep(day.trim(), language).trim())
    .join(', ');
};

const replaceOrKeep = (day: string, language: Language): string => {
  const workdayOption = workdayOptions.find((option) => option.value === day);
  if (workdayOption) return workdayOption.label[language];

  return day;
};
